import { render, staticRenderFns } from "./floor-header.vue?vue&type=template&id=38aad804"
import script from "./floor-header.vue?vue&type=script&lang=js"
export * from "./floor-header.vue?vue&type=script&lang=js"
import style0 from "./floor-header.vue?vue&type=style&index=0&id=38aad804&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports